import { Theme } from '@mui/material'

const classes = {
  slidesContainer: {
    overflow: 'hidden',
    width: 'calc(100% + 16px)',
  },
  slides: {
    display: 'flex',
    touchAction: 'pan-y pinch-zoom',
  },
  slide: (theme: Theme) => ({
    flex: '0 0 88%',
    minWidth: 0,
    paddingLeft: theme.spacing(2),
  }),
  dotButtonIcon: {
    fontSize: '8px',
  },
  controlsContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: '60px',
    marginTop: 3,
  },
  chevronIcon: (color?: string) => ({ color }),
  dotIcon: (color?: string, isSelected?: boolean) => ({
    fontSize: '8px',
    opacity: isSelected ? 1 : 0.5,
    color,
  }),
}

export default classes
